import { useResetPassword } from '@/domain/auth';

import { ResetPassword } from './ResetPassword';

export function ResetPasswordContainer() {
    const token = new URLSearchParams(window.location.search).get('token') || null;

    const resetPassword = useResetPassword();

    return (
        <ResetPassword
            hasToken={!!token}
            // The form is only shown with a token, so the rejection is never reached from the UI.
            resetPassword={({ newPassword }: { newPassword: string }) =>
                token
                    ? resetPassword({ newPassword, token })
                    : Promise.reject(new Error('A password reset needs the token from the link'))
            }
            onSuccessfulReset={() => {
                window.location.replace('/');
            }}
        />
    );
}
